// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1BRRE","bigColWidth":"Table_bigColWidth__1j1k5","biggerColWidth":"Table_biggerColWidth__31ulR","row":"Table_row__6yz99","col":"Table_col__1S8Zd"};